export default "__VITE_ASSET__b0177500__"